module.exports = __webpack_public_path__ + "img/down-phz1.007afe21.jpg";